import { businessTravelInputsUK } from './regions/UK-business-travel.input'
import { businessTravelInputsUS } from './regions/US-business-travel.input'

export const businessTravelMapping: { [key: string]: any } = {
  US: businessTravelInputsUS,
  UK: businessTravelInputsUK,
}
